import { fetchConstants } from '@/api/constant';
import { locales } from '@/locales';
import { getLocale, setLocale } from '@/common/locale';
import { fetchServiceConfig } from '@/api/config';
import Cookies from 'js-cookie';
import i18n from '@/i18n';

i18n.global.locale.value = getLocale();

export const state = {
	constants: null,
	config: null,
	locales,
	locale: getLocale(),
	inviter_code: null,
	isMerchant: false,
	isLoading: false,
};

export const mutations = {
	SET_CONSTANTS(state, newValue) {
		state.constants = newValue;
	},
	SET_LOCALE(state, locale) {
		state.locale = locale;
		i18n.global.locale.value = locale;
		setLocale(locale);
	},
	SET_CONFIG(state, newValue) {
		state.config = newValue;
	},
	SET_INVITER_CODE(state, newValue) {
		state.inviter_code = newValue;
	},
	SET_IS_MERCHANT(state, newValue) {
		state.isMerchant = newValue;
	},
	SET_IS_LOADING(state, newValue) {
		state.isLoading = newValue;
	},
};

export const getters = {
	is_inited(state) {
		return !!state.constants;
	},
	isLoading(state) {
		return state.isLoading;
	},
};

export const actions = {
	init({ dispatch }) {
		return Promise.all([
			dispatch('getConstants'),
			dispatch('getConfig'),
			dispatch('setInviterCode'),
		]);
	},

	async getConstants({ commit }) {
		const { constants } = await fetchConstants();

		commit('SET_CONSTANTS', constants);

		return constants;
	},
	async setLocale({ commit, dispatch, rootGetters }, locale) {
		commit('SET_LOCALE', locale);
		if (rootGetters['auth/is_logged_in']) {
			dispatch('account/getAccounts', null, {
				root: true,
			});
		}
		return Promise.all([
			dispatch('assets/getAssets', null, {
				root: true,
			}),
			dispatch('getConstants'),

			dispatch('getConfig'),
		]);
	},
	async getConfig({ commit }) {
		const { config } = await fetchServiceConfig();
		commit('SET_CONFIG', config);
		return config;
	},
	setInviterCode({ commit }, inviter_code) {
		if (inviter_code) {
			Cookies.set(
				'inviter_code',
				inviter_code,
				60 * 60 * 24 * 7,
				'/',
				document.domain.replace(/^m\./i, ''),
			);
		} else {
			inviter_code = Cookies.get('inviter_code') || null;
		}
		commit('SET_INVITER_CODE', inviter_code);
	},
};
